import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import { Title } from '@fs/zion-head'
import { Divider } from '@fs/zion-ui'

import FamilyInterviewQuestionsHero from './sections/FamilyInterviewQuestionsHero'
import AppDownloadSectionTop from './sections/AppDownloadSectionTop'
import BasicFamilyHistorySection from './sections/BasicFamilyHistorySection'
import HowToStartSection from './sections/HowToStartSection'
import HelpfulTipsSection from './sections/HelpfulTipsSection'
import ReadyToStartSection from './sections/ReadyToStartSection'
import StoriesAndMemoriesSection from './sections/StoriesAndMemoriesSection'
import PreserveFamilyStoriesSection from './sections/PreserveFamilyStoriesSection'

export default function FamilyInterviewQuestionsPage() {
  usePageView({ page_detail: 'familyInterviewQuestions' })
  const [t] = useTranslation()

  return (
    <>
      <Title>{t('tree-overview.family-interview.meta.title', 'Family Interview Questions')}</Title>

      <FamilyInterviewQuestionsHero />
      <AppDownloadSectionTop />
      <BasicFamilyHistorySection />
      <Divider />
      <HowToStartSection />
      <Divider />
      <HelpfulTipsSection />
      <ReadyToStartSection />
      <StoriesAndMemoriesSection />
      <PreserveFamilyStoriesSection />
    </>
  )
}
